export default {
  slabs: [
    {
      minsample: 500,
      maxsample: 1000,
      minir: 10,
      maxir: 49,
      rate: 0,
      flat: 14000,
    },
    {
      minsample: 500,
      maxsample: 1000,
      minir: 50,
      maxir: 100,
      rate: 0,
      flat: 6000,
    },
    {
      minsample: 1001,
      maxsample: 2000,
      minir: 10,
      maxir: 49,
      rate: 0,
      flat: 25000,
    },
    {
      minsample: 1001,
      maxsample: 2000,
      minir: 50,
      maxir: 100,
      rate: 0,
      flat: 12000,
    },
  ],
  additionalRate: 10,
};
